import { ReactNode, useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';
import Nprogress from 'nprogress';

type Props = {
  children: ReactNode;
};

export function RouteIndicatorProvider(props: Props) {
  const { children } = props;
  const router = useRouter();
  const indicator = Nprogress.configure({
    showSpinner: false,
    easing: 'ease-in',
    template: `
		<div class="bg-secondaryMain fixed z-50 top-0 left-0 w-full h-4 tr" role="bar">
	  		<div class="page-loading-indicator-tilt block absolute right-0 w-104 h-full opacity-100 shadow-page-loading-indicator"></div>
	  	</div>`,
  });

  useEffect(() => {
    const startSubscription = router.subscribe('onBeforeLoad', () => {
      indicator.start();
    });

    const onResolvedSubscription = router.subscribe('onResolved', () => {
      indicator.done();
    });

    return () => {
      startSubscription();
      onResolvedSubscription();
    };
  }, [router]);

  return children;
}
